import { render } from "./Staff.vue?vue&type=template&id=ab491b68"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=ab491b68&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__